<template>
  <div class="col-12">
    <div class="card card-outline card-navy">
      <div class="card-header">
        <h3 class="card-title">Contratos de Servicios</h3>

        <div class="card-tools">
          <button @click="newContract()" class="btn btn-sm btn-outline-info" v-can="'add_service_contracts'">
            <i class="fa fa-plus"></i> Contrato
          </button>
        </div>
      </div>

      <div class="card-body">
        <!-- Filters -->
        <div class="row">
          <div class="col-md-4">
            <label>Contrato (ID):</label>
            <input type="number" class="form-control" v-model="search.contract_id" />
          </div>

          <div class="col-md-4">
            <label>Tipo contrato:</label>
            <select class="form-control" v-model="search.contract_type_id">
              <option value="">Todos</option>
              <option v-for="(type, i) in catalogue.contract_services_type" :key="i" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label>Proveedor:</label>
            <select class="form-control" v-model="search.provider_id">
              <option value="">Todos</option>
              <option v-for="(provider, i) in providers" :key="i" :value="provider.id">
                {{ provider.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4 mt-2">
            <label>Cliente:</label>
            <select class="form-control" v-model="search.client_id">
              <option value="">Todos</option>
              <option v-for="(client, i) in clients" :key="i" :value="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4 mt-2">
            <label>Estatus:</label>
            <select class="form-control" v-model="search.status">
              <option value="">Todos</option>
              <option value="1">Activo</option>
              <option value="2">Inactivo</option>
            </select>
          </div>

          <div class="col-md-4 mt-2">
            <label>Buscar (descripción):</label>
            <input type="text" class="form-control" v-model="search.service_description" />
          </div>
        </div>

        <br>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-bordered text-center text-sm table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <!-- <th>Contrato</th> -->
                <th>Tipo</th>
                <th>Proveedor / Cliente</th>
                <th>Vigencia</th>
                <th>Total</th>
                <th>Estatus</th>
                <th style="width:210px;">Opciones</th>
              </tr>
            </thead>

            <tbody v-if="load">
              <tr>
                <td align="center" colspan="8">
                  <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                  <h5>Cargando</h5>
                </td>
              </tr>
            </tbody>

            <tbody v-else-if="serviceContracts.total > 0">
              <tr v-for="(row, index) in serviceContracts.data" :key="index">
                <td>{{ row.id }}</td>

                <!-- <td class="text-center">
                  <strong>#{{ row.contract_id }}</strong>
                </td> -->

                <td>
                  <span v-if="row.contract_type">
                    {{ row.contract_type.name }}
                  </span>
                  <span v-else class="badge badge-secondary">Sin tipo</span>
                </td>

                <td class="text-center">
                  <div><strong>Proveedor:</strong><br>
                    <span v-if="row.provider">
                      {{ row.provider.name }} {{ row.provider.last_name }}
                    </span>
                    <span v-else class="badge badge-secondary">
                      Sin proveedor
                    </span>
                  </div>
                  <hr>
                  <div><strong>Cliente:</strong><br>
                    <span v-if="row.client">
                      {{ row.client.name }} {{ row.client.last_name }}
                    </span>
                    <span v-else class="badge badge-secondary">
                      Sin cliente
                    </span>
                  </div>
                </td>

                <td>
                  <div><strong>Inicio:</strong><br> {{ row.start_date | toDateTime }}</div>
                  <hr>
                  <div><strong>Fin:</strong><br> {{ row.end_date | toDateTime }}</div>
                </td>

                <td>
                  <strong>{{ row.total | toCurrency }}</strong>
                </td>

                <td>
                  <span v-if="row.status == 1" class="badge badge-success">Activo</span>
                  <span v-else-if="row.status == 0" class="badge badge-secondary">Inactivo</span>
                  <span v-else class="badge badge-danger">Cancelado</span>
                </td>

                <td>
                  <button @click="newContractShow(row)" class="btn m-1 btn-outline-primary btn-sm">
                    <i class="fas fa-eye"></i> Ver
                  </button>

                  <button @click="newContract(row)" class="btn m-1 btn-outline-primary btn-sm" v-can="'edit_service_contracts'">
                    <i class="fas fa-edit"></i> Editar
                  </button>

                  <button type="button" @click="deleted(row.id)" class="btn-outline-danger btn m-1 btn-sm" v-can="'delete_service_contracts'">
                    <i class="fa fa-trash"></i> Eliminar
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td align="center" colspan="8">Sin resultados.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination v-model="page" :records="serviceContracts.total || 0" :per-page="serviceContracts.per_page || 15"
          @paginate="list" />
      </div>
    </div>
    <ModalServiceContractForm :prop_edit="show" />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import ModalServiceContractForm from '@/components/contracts_services/ModaFormComponent.vue';

export default {
  name: "service-contracts-table",
  components: {
    Pagination,
    ModalServiceContractForm
  },
  data() {
    return {
      serviceContracts: {},
      search: {
        contract_id: '',
        contract_type_id: '',
        provider_id: '',
        client_id: '',
        status: '',
        service_description: '',
      },
      clients: [],
      providers: [],
      page: 1,
      load: false,
      catalogue: new Catalogue(),
      show:true
    }
  },
  async mounted() {
    this.setHeaderTitle('Contratos de Servicios');
    await this.catalogue.getContractServicesType();
    // Clientes 
    await this.catalogue.get_users_profile(9);
    this.clients = this.catalogue.users_profile;
    // Proveedores
    await this.catalogue.get_users_profile(2);
    this.providers = this.catalogue.users_profile;

    this.list();
  },
  created() {
    Event.$on("event-load-service-contracts", () => {
      this.list();
    });
  },
  methods: {
    newContract(contract = {}) {
      this.show = true;
      Event.$emit("event-show-service-contract-form", contract);
    },
    newContractShow(contract = {}) {
      this.show = false;
      Event.$emit("event-show-service-contract-form", contract);
    },
    money(val) {
      let n = parseFloat(val || 0);
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },
    deleted(id) {
      let tit = 'Eliminar contrato';
      let txt = 'Seguro que quieres eliminar el contrato de servicio';

      this.$swal({
        title: tit,
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.callDeleted(id);
        }
      });
    },

    async callDeleted(id) {
      let _endpoint = '/service-contracts/' + id;
      try {
        let response = await request.destroy(_endpoint).then(r => r);
        this.list();
        this.successNotification(response.data.message);
      } catch (error) {
        await this.errorNotification(error);
      }
    },

    async list(page = 1) {
      this.load = true;
      let _endpoint = '/service-contracts';

      try {
        let { data } = await request.list(_endpoint, page, this.search);
        if (data) {
          this.serviceContracts = data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.load = false;
      }
    },

    ...mapMutations({
      setHeaderTitle: 'setHeaderTitle',
    }),
    ...mapActions({
      errorNotification: 'alert/error',
      successNotification: 'alert/success',
    }),
  },
  computed: {
    ...mapGetters({
      'authUser': 'auth/user'
    })
  },
  watch: {
    search: {
      handler() {
        this.list();
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-bottom: 0;
}

td {
  vertical-align: middle;
}
</style>
